/**
 * LogoutButtonContainer component.
 */
import styled from 'styled-components';

/**
 * Styled logout button container.
 */
const LogoutButtonContainer = styled.div`
  position: relative;
`;

export default LogoutButtonContainer;
